/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_LeadInputs */

const en_mk_cmp_notion_lead = /** @type {(inputs: Mk_Cmp_Notion_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion excels as a place to write and organise knowledge, and Custom Agents let it act. What differs here is firmness: work has a status and an owner, and outbound actions wait for a yes.`)
};

const id_mk_cmp_notion_lead = /** @type {(inputs: Mk_Cmp_Notion_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion unggul sebagai tempat menulis dan menyusun pengetahuan, dan Custom Agents membuatnya bisa bertindak. Yang berbeda di sini adalah ketegasan: pekerjaan punya status dan penanggung jawab, dan tindakan keluar menunggu persetujuan.`)
};

/**
* | output |
* | --- |
* | "Notion excels as a place to write and organise knowledge, and Custom Agents let it act. What differs here is firmness: work has a status and an owner, and ou..." |
*
* @param {Mk_Cmp_Notion_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_lead = /** @type {((inputs?: Mk_Cmp_Notion_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_lead(inputs)
	return en_mk_cmp_notion_lead(inputs)
});